import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_3 = ["required", "disabled"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "error" }
const _hoisted_6 = {
  key: 0,
  class: "form-text text-muted"
}

import { ref, computed, watch, onMounted, toRef } from 'vue'
    import { formatStringForDateInput } from "@common/Common"

    import type { AlternativeEditorAttributeFieldReadModel } from "@Alternatives/Alternatives/Domain/readmodels"
    import type { ValidationError } from "@common/types"

    /* props */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DateListMultiValue',
  props: {
    propF: {},
    propErrors: {}
  },
  setup(__props: any) {

    const props = __props

    /* shortcuts */

    const f = toRef(props, 'propF')
    const errors = toRef(props, 'propErrors')

    /* derived */

    const error = computed(() =>
        errors.value?.find(e =>
            e.Context.startsWith(`AlternativeAttribute:${f.value.Id}`)
        )?.Error
    )

    /* local state */

    const values = ref<string[]>([])

    /* defined values (derived, not state) */

    const definedValues = computed(() =>
        f.value.DefinedValues.map(dv => ({
            value: formatStringForDateInput(dv.Value),
            label: dv.Label
        }))
    )

    /* sync back to domain */

    watch(values, (vals) =>
    {
        f.value.Values = vals
    })

    /* init */

    onMounted(() =>
    {
        values.value = f.value.Values.map(v => formatStringForDateInput(v))
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      (f.value.IsRequired)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString(f.value.Name), 1 /* TEXT */)
    ]),
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((values).value = $event)),
      class: "form-control",
      multiple: "",
      required: f.value.IsRequired,
      disabled: f.value.IsReadonly
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(definedValues.value, (dv) => {
        return (_openBlock(), _createElementBlock("option", {
          key: dv.value,
          value: dv.value
        }, _toDisplayString(dv.label), 9 /* TEXT, PROPS */, _hoisted_4))
      }), 128 /* KEYED_FRAGMENT */))
    ], 8 /* PROPS */, _hoisted_3), [
      [_vModelSelect, values.value]
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(error.value), 1 /* TEXT */),
    (f.value.Description)
      ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(f.value.Description), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})